import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  drawerBackdropBlurStyle,
  elevatedSurfaceBoxShadow,
  shadowNotificationListItem,
  transition,
} from '../../../shared/style-settings'

export const useBundleNotificationsDrawerStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdropBlur: drawerBackdropBlurStyle,
    drawerContent: {
      width: 400,
      padding: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100vw',
        maxWidth: 400,
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
    },
    readTypeSelect: {
      width: '100% !important',
      minWidth: '0 !important',
      alignSelf: 'stretch',
      marginBottom: theme.spacing(1),
    },
    title: {
      fontWeight: 600,
    },
    closeButton: {
      cursor: 'pointer',
      padding: theme.spacing(1),
      '&:hover': {
        opacity: 0.7,
      },
    },
    content: {
      marginTop: theme.spacing(1),
      flex: 1,
      overflowY: 'auto',
    },
    bundleItems: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      marginTop: theme.spacing(2),
    },
    bundleItem: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
      padding: theme.spacing(2),
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
    },
    itemImage: {
      width: 80,
      height: 80,
      objectFit: 'cover',
      borderRadius: theme.shape.borderRadius,
    },
    itemInfo: {
      flex: 1,
    },
    description: {
      marginTop: theme.spacing(2),
      color: theme.palette.text.secondary,
    },
    notificationsSection: {
      paddingTop: theme.spacing(3),
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    sectionTitle: {
      marginBottom: theme.spacing(2),
      fontWeight: 600,
    },
    notificationsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    notificationItem: {
      padding: theme.spacing(2),
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius * 2,
      backgroundColor: theme.palette.background.paper,
      boxShadow: elevatedSurfaceBoxShadow,
      position: 'relative',
      transition: transition,
      '&:hover': {
        boxShadow: shadowNotificationListItem,
        borderColor: theme.palette.primary.light,
        transform: 'translateY(-2px)',
      },
    },
    notificationHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    notificationIcon: {
      fontSize: 20,
      color: theme.palette.primary.main,
    },
    notificationChip: {
      height: 20,
      fontSize: '0.7rem',
      fontWeight: 600,
    },
    notificationSubject: {
      fontWeight: 700,
      color: theme.palette.text.primary,
      lineHeight: 1.4,
      marginBottom: theme.spacing(0.5),
    },
    notificationText: {
      color: theme.palette.text.secondary,
      fontWeight: 600,
      fontSize: '0.8125rem',
      lineHeight: 1.45,
      marginBottom: theme.spacing(1),
    },
    notificationDate: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      marginTop: theme.spacing(1),
    },
    dateIcon: {
      fontSize: 14,
      color: theme.palette.text.secondary,
    },
    dateCaption: {
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    markAsReadButton: {
      marginTop: theme.spacing(1),
      textTransform: 'none',
      fontSize: '0.75rem',
      fontWeight: 600,
      padding: theme.spacing(0.5, 1),
      minWidth: 'auto',
    },
    emptyStateWrap: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    footerButton: {
      position: 'sticky',
      bottom: 0,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.divider}`,
      marginTop: theme.spacing(2),
      marginLeft: -theme.spacing(3),
      marginRight: -theme.spacing(3),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    seeAllButton: {
      textTransform: 'none',
      fontWeight: 600,
    },
    orderLinkButton: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      textTransform: 'none',
      fontSize: '0.75rem',
      fontWeight: 600,
    },
  })
)
